import { render, staticRenderFns } from "./remainingDays.vue?vue&type=template&id=7e59bea2&lang=pug&"
import script from "./remainingDays.vue?vue&type=script&lang=js&"
export * from "./remainingDays.vue?vue&type=script&lang=js&"
import style0 from "./remainingDays.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
